import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Button, Box, Typography, LinearProgress } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';

export default function StripePaymentForm({
  clientSecret,
  onSubmit,
  processing,
  error,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!stripe) {
      return;
    }
    if (!clientSecret) {
      return;
    }
  }, [stripe, clientSecret]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      setMessage("Payment gateway is not ready. Please wait a moment.");
      return;
    }

    onSubmit(stripe, elements);
  };

  const handleElementChange = (event) => {
    if (event.error) {
      setMessage(event.error.message);
    } else {
      setMessage(null);
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        id="payment-element"
        onChange={handleElementChange}
        options={{ layout: "tabs" }}
      />
      <Box sx={{ mt: 3, position: "relative" }}>
        <Button
          disabled={processing || !stripe || !elements}
          fullWidth
          variant="contained"
          type="submit"
          sx={{
            height: "48px",
            background:
              "linear-gradient(180deg, rgba(255, 240, 0, 1) 0, rgba(236, 198, 0, 1) 100%)",
            color: "#000",
            "&.Mui-disabled": {
              color: "#00000078",
              boxShadow: "none",
              background:
                "linear-gradient(180deg, rgb(255 240 0 / 80%) 0, rgb(236 198 0 / 80%) 100%)",
            },
            "&:hover": {
              background:
                "linear-gradient(180deg, rgb(255 240 0 / 90%) 0, rgb(236 198 0 / 90%) 100%)",
            },
          }}
        >
          Pay Now&nbsp;
          <LockIcon sx= {{mb:'6px'}}fontSize="small" />
        </Button>

        {message && (
          <Typography color="error" sx={{ mt: 1 }} id="payment-message">
            {message}
          </Typography>
        )}
        {error && !message && (
          <Typography color="error" sx={{ mt: 1 }} id="error-message">
            {error}
          </Typography>
        )}

        {processing && (
          <Box sx={{ width: "100%", mt: 2 }}>
            <LinearProgress />
          </Box>
        )}
      </Box>
    </form>
  );
}
